module.exports = __webpack_public_path__ + "defaa33b686328eafb3b6542e13f6edb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/create_workshop_info/promote_workshop@3x.jpg
// module id = 649
// module chunks = 0